<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
  <span class="logo-mini">
    <a href="http://www.archea-biogas.de/"><img src="/static/img/bi-logo-archea-biogas2.svg" alt="Logo" class="img-responsive center-block logo"></a>
  </span>
      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!-- Messages-->
            <li class="dropdown messages-menu" v-for="registro of registros"  :key="registro.key" v-if="registro.controlador === 'Woodard' && registro.exibir">
              <a href="javascript:;"  data-toggle="dropdown">
                <i :class="registro.icone"></i>
                <span class="label label-success">{{registro.valor}}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header"><h3>{{registro.label}}: {{registro.valor}} {{registro.umedida}}</h3></li>
                <li class="header">
                  <p>{{registro.descricao}}</p>
                <!-- The message -->
                <p>{{registro.data}} - {{registro.hora}}</p>
                  <!-- /.menu -->
                </li>
                <li class="footer" v-if="userInfo.messages.length > 0">
                </li>
              </ul>
            </li>
            <!-- /.messages-menu -->
          </ul>
        </div>
      </nav>
    </header>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import MessagesMenu from './MessagesMenu'
import NotificationsMenu from './NotificationsMenu'
import 'hideseek'
import TasksMenu from './TasksMenu'
import UserMenu from './UserMenu'
import {db} from '../../firebase'
import Sidebar from './Sidebar'

export default {
  name: 'DashHeader',
  components: {
    MessagesMenu,
    NotificationsMenu,
    TasksMenu,
    UserMenu,
    Sidebar
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: false,
        hide_logo: false
      },
      error: '',
      registros: {}
    }
  },
  firebase: {
    registros: {
      source: db.ref('registradoronline'),
      cancelCallback (err) {
        console.error(err)
      }
    }
  },
  props: ['user'],
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashHeader.vue?79f64f6e